import { Box, styled, Theme } from '@mui/material';
type StyledSearchSiteBoxType = {
  theme: Theme;
};

const addButtonContainer = {
  width: '100%',
  marginTop: '28px',
  marginBottom: '24px',
  display: 'flex',
  justifyContent: 'flex-end',
};

const StyledSearchBox = styled(Box)(({ theme }: StyledSearchSiteBoxType) => ({
  display: 'flex',
  padding: '15px',
  position: 'relative',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.palette.background.default,
}));
export { addButtonContainer, StyledSearchBox };
